import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import BankPortal from 'src/components/bankPortal/BankPortal'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  // Typography,
  Button,
} from '@material-ui/core'
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { getPublicCoursesStatus, selectorPublicCoursesStatus } from '../../../app/slices/courseSlice'
import styles from './PublicCourse.module.css'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& .MuiAccordion-rounded': {
      '&:last-child': {
        borderBottomRightRadius: '20px',
        borderBottomLeftRadius: '20px',
      },
    },
    '& .MuiAccordionSummary-content': {
      justifyContent: 'end',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}))

const PublicCourseHeader = () => {
  const publicCoursesStatus = useSelector(selectorPublicCoursesStatus)
  const dispatch = useDispatch()
  const classes = useStyles()

  const [day, setDay] = useState('')
  const [hour, setHour] = useState('')
  const [minutes, setMinutes] = useState('')
  const [second, setSecond] = useState('')

  // const countDownDate = new Date('jun 20, 2022 15:37:25').getTime()
  // const countDownDate = new Date().getTime() === 'NaN'
  // const countDownDate = new Date().getTime() === 'NaN'
  //   ? new Date().getTime()
  //   : new Date(expireDate).getTime()

  // console.log(expireDate);

  // const countDownDate = publicCoursesStatus?.expireDate
  //   ? new Date(publicCoursesStatus?.ExpireDate).getTime() : 0

  const countDownDate = publicCoursesStatus?.data?.status === 103
    ? new Date(publicCoursesStatus?.data?.expireDate).getTime() : 0

  useEffect(() => {
    dispatch(getPublicCoursesStatus())
  }, [])

  // '2022-05-25T13:46:40+04:30'

  const x = setInterval(() => {
    const now = new Date().getTime()

    const distance = countDownDate - now

    setDay(Math.floor(distance / (1000 * 60 * 60 * 24)).toString())
    setHour(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
    setMinutes(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)))
    setSecond(Math.floor((distance % (1000 * 60)) / 1000))

    if (distance < 0) {
      clearInterval(x)
    }
  }, 1000)

  let days = null
  if (day.toString().length <= 1) {
    // console.log('1')
    days = (
      <div className={styles.time}>
        <span className={styles.timerNumber}>0</span>
        <span className={styles.timerNumber}>{day.toString()[0]}</span>
      </div>
    )
  } else if (day.toString().length <= 2) {
    // console.log('2')
    days = (
      <div className={styles.time}>
        <span className={styles.timerNumber}>{day.toString()[0]}</span>
        <span className={styles.timerNumber}>{day.toString()[1]}</span>
      </div>
    )
  } else if (day.toString().length >= 3) {
    // console.log('3')
    days = (
      <div className={styles.time}>
        <span className={styles.timerNumber}>{day.toString()[0]}</span>
        <span className={styles.timerNumber}>{day.toString()[1]}</span>
        <span className={styles.timerNumber}>{day.toString()[2]}</span>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <div className={styles.description}>
        <div className={styles.payWrapp}>
          <p
            className={styles.descText}
            style={{
              width: 'auto',
              lineHeight: '25px',
              padding: '10px',
            }}
          >
            {publicCoursesStatus?.message}
          </p>
          {publicCoursesStatus?.data?.status === 108 && (
          <Accordion style={{ marginTop: '8px' }}>
            <AccordionSummary
          // expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Button className={classes.heading} variant="contained" color="primary">
                پرداخت
              </Button>
            </AccordionSummary>
            <AccordionDetails>
              <BankPortal expired />
            </AccordionDetails>
          </Accordion>
          )}
        </div>
        {publicCoursesStatus?.data?.status === 103 ? (
          <div className={styles.timerWrap}>
            <p className={styles.timerText}>فرصت باقیمانده:</p>
            {publicCoursesStatus?.data?.expireDate ? (
              <div className={styles.timerNumbersWrap}>
                <div className={styles.timeWrap}>
                  {second.toString().length <= 1 ? (
                    <div className={styles.time}>
                      <span className={styles.timerNumber}>0</span>
                      <span className={styles.timerNumber}>{second}</span>
                    </div>
                  ) : (
                    <div className={styles.time}>
                      <span className={styles.timerNumber}>
                        {second.toString()[0]}
                      </span>
                      <span className={styles.timerNumber}>
                        {second.toString()[1]}
                      </span>
                    </div>
                  )}
                  <span style={{ paddingTop: '14px' }}>ثانیه</span>
                </div>
                :
                <div className={styles.timeWrap}>
                  {minutes.toString().length <= 1 ? (
                    <div className={styles.time}>
                      <span className={styles.timerNumber}>0</span>
                      <span className={styles.timerNumber}>{minutes}</span>
                    </div>
                  ) : (
                    <div className={styles.time}>
                      <span className={styles.timerNumber}>
                        {minutes.toString()[0]}
                      </span>
                      <span className={styles.timerNumber}>
                        {minutes.toString()[1]}
                      </span>
                    </div>
                  )}
                  <span style={{ paddingTop: '14px' }}>دقیقه</span>
                </div>
                :
                <div className={styles.timeWrap}>
                  {hour.toString().length <= 1 ? (
                    <div className={styles.time}>
                      <span className={styles.timerNumber}>0</span>
                      <span className={styles.timerNumber}>{hour}</span>
                    </div>
                  ) : (
                    <div className={styles.time}>
                      <span className={styles.timerNumber}>
                        {hour.toString()[0]}
                      </span>
                      <span className={styles.timerNumber}>
                        {hour.toString()[1]}
                      </span>
                    </div>
                  )}
                  <span style={{ paddingTop: '14px' }}>ساعت</span>
                </div>
                :
                <div className={styles.timeWrap}>
                  {days}
                  <span style={{ paddingTop: '14px' }}>روز</span>
                </div>
              </div>
            ) : (
            // <span style={{ margin: '0 auto' }}>مدت زمان شما به اتمام رسیده</span>
              null
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default PublicCourseHeader
